import { z } from "zod";
import { FeatureGating, ReRouteBackButton, GameControllerSupport, LocalNotificationsSchema, OnDeviceCache, IsScrollEnabled, PaywallDismissal, PaywallPresentationStyle, ShowPaywallOption, SurveyPresentationCondition } from "../models";
import { PageStyles, SubSchema } from "../paywall-js";
// export const FeatureGating = {
//   GATED: "GATED",
//   NON_GATED: "NON_GATED",
// }
// export const OnDeviceCache = {
//   ENABLED: "ENABLED",
//   DISABLED: "DISABLED",
// }
// export const PaywallDismissal = {
//   NORMAL: "NORMAL",
//   DISABLED: "DISABLED",
// }
// export const PaywallPresentationStyle = {
//   FULLSCREEN: "FULLSCREEN",
//   MODAL: "MODAL",
//   PUSH: "PUSH",
//   NO_ANIMATION: "NO_ANIMATION",
//   DRAWER: "DRAWER",
// }
export const PaywallTemplateType = {
    GLOBAL: "GLOBAL",
    ORGANIZATION: "ORGANIZATION",
    UNLISTED: "UNLISTED"
};
export const PaywallTemplateCategories = z.array(z.string());
// export const SurveyPresentationCondition = {
//   ON_MANUAL_CLOSE: "ON_MANUAL_CLOSE",
//   ON_PURCHASE: "ON_PURCHASE",
// }
// export const ShowPaywallOption = {
//   EXPLICIT: "EXPLICIT",
//   ON_FIRST_LAUNCH: "ON_FIRST_LAUNCH",
//   ON_NTH_LAUNCH: "ON_NTH_LAUNCH",
// }
export const PresentationCondition = {
    CHECK_USER_SUBSCRIPTION: "CHECK_USER_SUBSCRIPTION",
    ALWAYS: "ALWAYS"
};
export const DisablePaywallOptionReAssign = z.object({
    type: z.literal("re-assign"),
    reassignToPaywallId: z.number()
});
export const DisablePaywallOptionDoNothing = z.object({
    type: z.literal("do-nothing")
});
export const DisablePaywallOptionUnassign = z.object({
    type: z.literal("un-assign")
});
export const DisablePaywallOptions = z.union([
    DisablePaywallOptionReAssign,
    DisablePaywallOptionUnassign,
    DisablePaywallOptionDoNothing
]);
// This is a change from what's happening in apps/web
// but it's coming from the old paywalls
export const LiquidString = z.string();
export const substitutionSchema = SubSchema.omit({
    value: true,
    freeTrialValue: true
}).extend({
    value: LiquidString,
    freeTrialValue: LiquidString.optional()
});
export const Substitutions = z.array(substitutionSchema);
export const Paywall = z.object({
    name: z.string().min(1),
    url: z.string().url().transform((urlString)=>{
        // Make sure we remove the `transport` params from the url
        // b/c it breaks the sdk.
        try {
            let url = new URL(urlString);
            url.searchParams.delete("transport");
            return url.toString();
        } catch  {}
        return urlString;
    }),
    primaryProductIdentifier: z.string().nullable().optional(),
    secondaryProductIdentifier: z.string().nullable().optional(),
    tertiaryProductIdentifier: z.string().nullable().optional(),
    presentationCondition: z.nativeEnum(PresentationCondition).optional(),
    presentationStyle: z.nativeEnum(PaywallPresentationStyle).default(PaywallPresentationStyle.MODAL),
    showPaywallOption: z.nativeEnum(ShowPaywallOption).optional(),
    paywallDismissal: z.nativeEnum(PaywallDismissal).optional().default(PaywallDismissal.NORMAL),
    backgroundColorHex: z.string(),
    featureGating: z.nativeEnum(FeatureGating).optional(),
    reRouteBackButton: z.nativeEnum(ReRouteBackButton).optional(),
    gameControllerSupport: z.nativeEnum(GameControllerSupport).optional(),
    onDeviceCache: z.nativeEnum(OnDeviceCache).optional(),
    isScrollEnabled: z.nativeEnum(IsScrollEnabled).optional(),
    // TODO we may want to do this in the future, but for now the FE is handling
    // validation visually for the background color hex as well as page styles grouped styles colors.
    // .regex(/^\#?[0-9a-fA-F]{6}$/, { message: "Color must match # and 6 hex characters" }),
    applicationId: z.number().optional(),
    substitutions: Substitutions,
    pageStyles: PageStyles,
    templateJson: z.object({}).passthrough().nullable().optional(),
    templateType: z.union([
        z.literal(PaywallTemplateType.GLOBAL),
        z.literal(PaywallTemplateType.UNLISTED),
        z.literal(PaywallTemplateType.ORGANIZATION)
    ]).nullable(),
    templateCategories: PaywallTemplateCategories.optional(),
    localNotifications: LocalNotificationsSchema.optional()
});
export const PaywallFormValidator = Paywall;
export const CreatePaywallPipeValidator = Paywall.extend({
    applicationId: z.number(),
    enabled: z.boolean().optional()
});
export const UpdatePaywallPipeValidator = Paywall.extend({
    id: z.number(),
    enabled: z.boolean().optional(),
    surveys: z.array(z.object({
        surveyId: z.number(),
        surveyPresentationCondition: z.nativeEnum(SurveyPresentationCondition)
    })).optional()
}).partial();
export var CloneOptionType = /*#__PURE__*/ function(CloneOptionType) {
    CloneOptionType["AsDuplicate"] = "clone-as-duplicate";
    CloneOptionType["AsTemplate"] = "clone-as-template";
    CloneOptionType["AsUnlisted"] = "clone-as-unlisted";
    return CloneOptionType;
}({});
export const DuplicatePaywall = z.object({
    id: z.number(),
    name: z.string().optional(),
    targetApplicationId: z.number(),
    cloneOptionType: z.nativeEnum(CloneOptionType).default("clone-as-duplicate")
});
export const DeletePaywall = z.object({
    id: z.number()
});
